var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.$tr("removeStorageLocation"),
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
      },
      on: {
        submit: _vm.handleSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c("p", { staticClass: "description" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$tr("removeStorageLocationDescription")) +
            "\n  "
        ),
      ]),
      _c("p", [_vm._v(_vm._s(_vm.$tr("deleteFilesDescription")))]),
      _vm._l(_vm.storageLocations, function (path) {
        return _c("KRadioButton", {
          key: path.index,
          attrs: { value: path, label: path },
          model: {
            value: _vm.selectedPath,
            callback: function ($$v) {
              _vm.selectedPath = $$v
            },
            expression: "selectedPath",
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }